import React from 'react';
import MerchantDetailsComponentProps from '../merchantDetailsComponentProps';
import FeatureFlagEditor from 'features/featureFlags/FeatureFlagEditor';
import merchantService from '../merchantService';
import loggingService from 'common/logging/loggingService';
import notificationService from 'common/notificationService';

const Features: React.FC<MerchantDetailsComponentProps> = props => {

    async function onChange(code: string, value: boolean) {
        const originalMerchant = props.merchant;
        try {
            const newFlags = props.merchant.featureFlags.map(m => m.code === code ? { ...m, value: value} : m);
            props.setMerchant({...props.merchant, featureFlags: newFlags})
            await merchantService.updateMerchant(props.merchant.id, {
                featureFlags: [ {code, value} ]
            });
        }
        catch (err) {
            loggingService.error("Error updating feature flag", err as Error);
            notificationService.error("Error updating feature flag");
            props.setMerchant(originalMerchant);
        }
    }

    return <div className="features">
        {props.merchant.featureFlags.map(m => 
            <FeatureFlagEditor key={m.code}
                code={m.code}
                name={m.name}
                description={m.description}
                value={m.value}
                onChange={val => onChange(m.code, val)}
                />
        )}
    </div>;
}

export default Features;